/* Bogart Engineering Theme JS v6.0 */
document.addEventListener('DOMContentLoaded', function() {

  // ── DROPDOWN NAV (click-based, not hover) ──────────────────────
  var dropdowns = document.querySelectorAll('.nav-item--dropdown');

  dropdowns.forEach(function(item) {
    var trigger = item.querySelector('.nav-link');
    var menu = item.querySelector('.nav-dropdown');
    if (!trigger || !menu) return;

    // Open/close on click
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = item.classList.contains('open');
      // Close all dropdowns first
      closeAll();
      // Toggle this one
      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    // Close when clicking a dropdown item
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        closeAll();
      });
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-item--dropdown')) {
      closeAll();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeAll();
  });

  function closeAll() {
    dropdowns.forEach(function(item) {
      item.classList.remove('open');
      var trigger = item.querySelector('.nav-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  // ── MOBILE NAV TOGGLE ──────────────────────────────────────────
  var toggle = document.getElementById('nav-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      var open = mobileNav.classList.contains('open');
      mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.classList.toggle('open');
    });
    // Close mobile nav when a link is clicked
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileNav.classList.remove('open');
        toggle.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── ACTIVE NAV ITEM ────────────────────────────────────────────
  var path = window.location.pathname;
  document.querySelectorAll('.nav-list > .nav-item > .nav-link').forEach(function(link) {
    var href = link.getAttribute('href');
    if (!href) return;
    if (href === '/' && path === '/') {
      link.classList.add('active');
    } else if (href !== '/' && path.startsWith(href)) {
      link.classList.add('active');
    }
  });

  // ── VARIANT SELECTOR ───────────────────────────────────────────
  var variantDataEl = document.getElementById('variant-data');
  if (variantDataEl) {
    var variantData = JSON.parse(variantDataEl.textContent || '[]');
    var selectedOpts = {};

    document.querySelectorAll('.variant-pills').forEach(function(group) {
      var idx = group.dataset.optionIndex;
      var first = group.querySelector('.variant-pill.selected') || group.querySelector('.variant-pill');
      if (first) selectedOpts[idx] = first.dataset.value;

      group.querySelectorAll('.variant-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          group.querySelectorAll('.variant-pill').forEach(function(p) {
            p.classList.remove('selected');
          });
          pill.classList.add('selected');
          selectedOpts[idx] = pill.dataset.value;
          var label = document.getElementById('opt-val-' + (parseInt(idx) + 1));
          if (label) label.textContent = pill.dataset.value;
          updateVariant();
        });
      });
    });

    function updateVariant() {
      var match = variantData.find(function(v) {
        var parts = v.title.split(' / ');
        return Object.values(selectedOpts).every(function(val, i) {
          return parts[i] === val;
        });
      });
      if (!match) match = variantData[0];
      var vidEl = document.getElementById('variant-id');
      if (vidEl) vidEl.value = match.id;
      var price = '$' + (match.price / 100).toFixed(2);
      var priceEl = document.querySelector('.price-current');
      if (priceEl) priceEl.textContent = price;
      var atcPrice = document.getElementById('atc-price-display');
      if (atcPrice) atcPrice.textContent = price;
      var btn = document.getElementById('atc-btn');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart' : 'Out of Stock';
      }
    }
  }

  // ── ACCORDION ──────────────────────────────────────────────────
  document.querySelectorAll('.accordion-header').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var body = this.nextElementSibling;
      var open = this.getAttribute('aria-expanded') === 'true';
      // Close all accordions in same group
      var parent = this.closest('.accordion');
      if (parent) {
        parent.querySelectorAll('.accordion-header').forEach(function(h) {
          h.setAttribute('aria-expanded', 'false');
          h.querySelector('.acc-arrow').textContent = '+';
          if (h.nextElementSibling) h.nextElementSibling.style.display = 'none';
        });
      }
      // Open clicked one if it was closed
      if (!open) {
        this.setAttribute('aria-expanded', 'true');
        this.querySelector('.acc-arrow').textContent = '−';
        body.style.display = 'block';
      }
    });
  });

  // ── STICKY HEADER SHADOW ───────────────────────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(0,0,0,0.3)'
        : '0 2px 12px rgba(0,0,0,0.15)';
    }, { passive: true });
  }

  // ── FADE-UP ANIMATIONS ─────────────────────────────────────────
  if ('IntersectionObserver' in window) {
    var fadeEls = document.querySelectorAll(
      '.product-card, .kit-card, .review-card, .why-card, .use-card, .strength-item'
    );
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

});
